export default __webpack_public_path__ + "static/media/Maps.ded4f5fa.jfif";